export const CROSSCUTTING_DONE_APPROVAL_LIST_FAILED = "CROSSCUTTING_DONE_APPROVAL_LIST_FAILED"
export const CROSSCUTTING_DONE_APPROVAL_LIST_REQUEST = "CROSSCUTTING_DONE_APPROVAL_LIST_REQUEST"
export const CROSSCUTTING_DONE_APPROVAL_LIST_SUCCESS = "CROSSCUTTING_DONE_APPROVAL_LIST_SUCCESS"